/**
 * RoutingCategoryIcon - Renderiza dinamicamente um ícone Lucide pelo nome
 *
 * Usado em categorias de Ações Rápidas: o usuário escolhe livremente um
 * ícone via picker, salvo como string em routing_rule_categories.icon.
 *
 * Faz fallback para o ícone "Zap" caso o nome não exista no pacote.
 *
 * CHANGELOG:
 *   2026-06-23 v1.0.0 - Versão inicial.
 */

import React from 'react';
import { icons, Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RoutingCategoryIconProps {
  /** Nome do ícone (PascalCase) da biblioteca Lucide. Ex: 'Zap', 'Star'. */
  name?: string | null;
  /** Cor (usa currentColor por padrão). */
  color?: string;
  /** Tamanho em pixels. */
  size?: number;
  /** Classes adicionais. */
  className?: string;
}

/**
 * Renderiza o ícone Lucide pelo nome salvo na categoria.
 */
export function RoutingCategoryIcon({
  name,
  color,
  size = 16,
  className,
}: RoutingCategoryIconProps) {
  // Lookup no map de ícones. Fallback é Zap.
  const Icon =
    (name && (icons as Record<string, React.ComponentType<any>>)[name]) || Zap;

  return (
    <Icon
      size={size}
      color={color}
      className={cn('shrink-0', className)}
      aria-hidden
    />
  );
}
